import { render } from "./TemplateCategoryList.vue?vue&type=template&id=e0ec8c8e"
import script from "./TemplateCategoryList.vue?vue&type=script&lang=ts"
export * from "./TemplateCategoryList.vue?vue&type=script&lang=ts"
script.render = render

export default script